import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { Container, Card, Spinner, Alert, Button } from 'react-bootstrap';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('');
  const token = searchParams.get('token');

  useEffect(() => {
    const verifyEmail = async () => {
      if (!token) {
        setStatus('error');
        setMessage('No verification token provided');
        return;
      }

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL || 'http://localhost:5001'}/api/auth/verify-email/${token}`
        );
        
        const data = await response.json();

        if (data.success) {
          setStatus('success');
          setMessage('Email verified successfully!');
          
          // Store token and user data
          if (data.token) {
            localStorage.setItem('token', data.token);
            localStorage.setItem('user', JSON.stringify(data.user));
          }
          
          // Redirect to dashboard after 2 seconds
          setTimeout(() => {
            navigate('/dashboard');
          }, 2000);
        } else {
          setStatus('error');
          setMessage(data.error || 'Verification failed');
        }
      } catch (error) {
        setStatus('error');
        setMessage('An error occurred during verification');
      }
    };

    verifyEmail();
  }, [token, navigate]);

  return (
    <div className="auth-page" style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    }}>
      <Container>
        <div className="d-flex justify-content-center">
          <Card style={{ maxWidth: '450px', width: '100%' }}>
            <Card.Body className="p-5 text-center">
              <h2 className="mb-4"><span role="img" aria-label="microphone">🎙️</span> EchoBrief</h2>
              
              {status === 'verifying' && (
                <>
                  <Spinner animation="border" variant="primary" className="mb-3" />
                  <p>Verifying your email...</p>
                </>
              )}
              
              {status === 'success' && (
                <>
                  <Alert variant="success">
                    <Alert.Heading>✅ Email Verified!</Alert.Heading>
                    <p>{message}</p>
                    <p className="mb-0">Redirecting to dashboard...</p>
                  </Alert>
                </>
              )}
              
              {status === 'error' && (
                <>
                  <Alert variant="danger">
                    <Alert.Heading><span role="img" aria-label="error">❌</span> Verification Failed</Alert.Heading>
                    <p>{message}</p>
                  </Alert>
                  <div className="mt-4">
                    <p>The verification link may have expired.</p>
                    <Link to="/login">
                      <Button variant="primary">Go to Login</Button>
                    </Link>
                  </div>
                </>
              )}
            </Card.Body>
          </Card>
        </div>
      </Container>
    </div>
  );
};

export default VerifyEmail;
